module.controller('venmoCtrl', ['$scope', '$state', '$http', '$filter', '$window', 'cacheService', 'Transform', 'baseURI', 'OVERLAY', '$rootScope', 'STATES', '$stateParams', 'accountService', function ($scope, $state, $http, $filter, $window, cacheService, Transform, baseURI, OVERLAY, $rootScope, STATES, $stateParams, accountService){

    var paypalUrl = baseURI + 'consumer-choice/paypal';

    $scope.overlay = OVERLAY['member.home.venmo'];

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to send your funds to Venmo at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.formData = {};

    $scope.states = STATES;

    $scope.formData.ServiceType = 'VENMO';

    $scope.account = accountService.getAccount($stateParams.username);

    $scope.balance = $scope.account.balance;

    $scope.formData.Amount = $scope.balance;

    $scope.amountValid = true;

    $scope.clearRecipientError = function() {
        $scope.recipientValid = true;
        $scope.recipientMessage = '';
    };

    // Adds context to the amount messaging
    $scope.formatAmountMessage = function(){
        if ($scope.formData.Amount > $scope.balance){
            $scope.amountValid = false;
            $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '.';
        }
        else if($scope.formData.Amount <= 0 || !$scope.formData.Amount) {
            $scope.amountValid = false;
            $scope.amountMessage = 'Please enter a valid amount.';
        } else {
            $scope.amountValid = true;
            $scope.amountMessage = 'ok';
        }
    };

    $scope.attemptSubmission = function (formData){
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var phoneRegex = /^[0-9]{10,15}$/;

        var recipient = $scope.formData.recipient;
        $scope.recipientValid = true;
        $scope.recipientMessage = '';

        if (!recipient) {
            $scope.recipientValid = false;
            $scope.recipientMessage = 'Please enter a valid email or phone number.';
            return;
        }

        if (recipient.includes('@')) {
            if (!emailRegex.test(recipient)) {
                $scope.recipientValid = false;
                $scope.recipientMessage = 'Please enter a valid email or phone number.';
                return;
            }
            $scope.formData.Phone = '';
            $scope.formData.Email = recipient;
            $scope.formData.RecipientType = 'email';
        } else {
            var phone = recipient.replace(/\D+/g, '');
            if (!phoneRegex.test(phone)) {
                $scope.recipientValid = false;
                $scope.recipientMessage = 'Please enter a valid email or phone number.';
                return;
            }
            $scope.formData.Email = '';
            $scope.formData.Phone = phone;
            $scope.formData.RecipientType = 'phone';
        }

        if(formData.$valid && $scope.amountValid){
            $scope.alert.errorShown = false;
            $state.go('member.home.venmo.step2', $scope.transferFrom);
        } else {
            $scope.alert.errorShown = true;
            $scope.attempted = true;
        }
    };

    $scope.processForm = function(formData){

        if ($scope.formData.RecipientType === 'email') {
            $scope.formData.Phone = '';
        } else {
            $scope.formData.Email = '';
        }

        var data  = Object.assign({}, $scope.formData);

        $http({
            method: 'POST',
            url: paypalUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            data: Transform.encode(data)
        }).then(function (resp){
            var data = resp.data;
            $scope.loading = false;
            if(data.Success){
                cacheService.clear('subcard');

                $state.go('member.home.venmo.step3', $scope.transferFrom);
                $scope.alert.successShown = true;
                $scope.alert.successMessage = 'You\'ve sent ' + $filter('akimboCurrency')(formData.Amount, '$') + ' to ' + formData.recipient;
            } else {
                $scope.invalidRequest = true;
            }
        }).catch(function (error){
            $scope.loading = false;
            $scope.alert.alertShown = true;
        });
    };
}]);
